
import React, { Component } from "react";

import { BsyUtils } from '../../../utils/Utils';
import BsySearchInput from "../../BsySearchInput";
import BsySearchResult from "../../BsySearchResult";
import tipAlert from "../../../Login/BsyAlertTip/Staticize";
import './index.css';
import { ReactSortable } from "react-sortablejs";
import { sortableContainer, sortableElement, sortableHandle } from 'react-sortable-hoc';
import { arrayMoveImmutable } from 'array-move';

const DragHandle = sortableHandle(() => <i className="icon-drag" />);

const SortableItem = sortableElement((props) => (
    <>{props.children}</>
));

const SortableContainer = sortableContainer(({ children }) => {
    return <div className={'speedy-entrys'}>{children}</div>;
});

export default class BsyDashboardSpeedyEntryConfig extends Component {

    constructor(props) {
        super(props)
        let ars = [];
        if (props.speedyEntry.entries) {
            BsyUtils.forEach(props.speedyEntry.entries, (key, res) => {
                ars.push(res)
            })
        }
        this.state = {
            apps: [],
            appMaps: {},
            speedyEntrys: ars,
            maxEntrys: 12,
            key: '',
            seachList: [],
        }

    }

    getAppList = () => {
        React.axios('/dashboard/app_group/list').then(res => {

            if (res.data.code === 0) {

                this.setState({
                    apps: [...res.data.items],
                }, () => {
                    // this.onSelectApp(this.state.appid);
                })
            } else {
                BsyUtils.showAjaxTip(res.data, () => {
                    this.setState({
                        apps: [...res.data.items],
                    }, () => {
                        // this.onSelectApp(this.state.appid);
                    })
                })
            }
        }).catch(res => {

        })
    }
    componentDidMount() {
        this.getAppList();
        this.getValue();
    }

    UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
        const items = { ...nextProps.speedyEntry }
        this.setState({
            speedyEntry: items
        })
    }

    entryClick = (e) => {
        e.stopPropagation();
    }

    onSelectApp = (_id, e) => {
        const { appMaps } = this.state;
        if (!_id) {
            return;
        }
        let event = e.currentTarget;
        if (appMaps[_id]) {
            const newAppMap = {
                ...appMaps,
                [_id]: { ...appMaps[_id], open: !appMaps[_id].open },
            }
            if (newAppMap[_id].open) {
                event.classList.add("open")
            } else {
                event.classList.remove("open")
            }
            this.setState({
                appMaps: newAppMap,
            })
            return;
        }
        React.axios('/dashboard/app/' + _id).then(res => {

            let entrys = [];
            window.FX.STATIC.user.dock_userid = res.data.dock_userid;
            res.data.entryList.map((data, index) => {
                if (data.child) {
                    // data.child.map((childdata, index) => {
                    //     entrys.push({ ...res.data.entryMap[childdata.id], appId: _id })
                    // })
                    BsyUtils.forEach(data.child, (index, childdata) => {
                        if (childdata.child) {
                            BsyUtils.forEach(childdata.child, (index, childdata1) => {
                                entrys.push({ ...res.data.entryMap[childdata1.id], appId: _id })
                            })
                        } else {
                            entrys.push({ ...res.data.entryMap[childdata.id], appId: _id })
                        }
                    })
                } else {
                    entrys.push({ ...res.data.entryMap[data.id], appId: _id })
                }
            })

            const newAppMap = {
                [_id]: { ...res.data, entrys: entrys, open: true },
                ...appMaps,
            }
            if (newAppMap[_id].open) {
                event.classList.add("open")
            } else {
                event.classList.remove("open")
            }
            this.setState({
                appMaps: newAppMap,
            })

        }).catch(res => {
            console.log(res)
        })
    }


    getSearchValue = (ref) => {
        this.searchValue = ref
    }

    onSearch = () => {

        let key = this.searchValue.getValue();
        if (!key) {
            this.setState({
                key: "",
                seachList: [],
            })
            return
        }
        React.axios('/dashboard/search', {
            keyword: key,
            type: "entry",
            range: 'noStandard'
        }).then(res => {
            this.setState({
                key: this.searchValue.getValue(),
                seachList: res.data.list,
            })
        }).catch(res => {
            console.error(res);
        })


    }
    findEntryS = (entry) => {
        const { speedyEntrys } = this.state;

        const s = speedyEntrys.filter((data, index) => {

            return data._id === entry._id
        })
        return s.length > 0;
    }
    entryDel = (entry) => {
        const { speedyEntrys } = this.state;
        const s = speedyEntrys.filter((data, index) => {
            return data._id !== entry._id
        })

        this.setState({
            speedyEntrys: s,
        }, () => {
            this.getValue(s);
        })
    }

    getValue = () => {
        const { speedyEntrys } = this.state;
        if (this.props.getValue) {
            this.props.getValue({ entries: speedyEntrys })
        }
    }

    entryAdd = (entry) => {
        const { speedyEntrys, maxEntrys } = this.state;

        const s = [...speedyEntrys, entry]
        this.setState({
            speedyEntrys: s,
        }, () => {
            this.getValue(s);
        })
    }

    entryAdd1 = (event, entry) => {
        const { speedyEntrys, maxEntrys } = this.state;

        const s = [...speedyEntrys, entry]
        this.setState({
            speedyEntrys: s,
        }, () => {
            this.getValue(s);
            let span = document.createElement("span");
            span.classList.add("read-tip");
            span.innerText = React.language('add.already');
            event.target.parentNode.appendChild(span);
            event.target.remove();
        })
    }

    renderEntryList = (appInfo) => {
        const { appMaps } = this.state;
        if (appMaps[appInfo._id]) {

            if (!appMaps[appInfo._id].open) {
                return '';
            }

            return <div className='app-entrys' >
                {
                    appMaps[appInfo._id].entrys.length > 0 ? appMaps[appInfo._id].entrys.map((data, index) => {
                        return <div className={'entry-item'} onClick={this.EntryClick} >
                            <i className={'entry-icon ' + BsyUtils.getFormIcon(data)} />
                            <span className={'entry-title'}>{data.name}</span>
                            <span className={'right-entry-title'}>{
                                this.findEntryS(data)
                                    ? <span className='read-tip'>{React.language('add.already')}</span>
                                    : <i className='icon-bsy-appAdd' onClick={e => { e.stopPropagation(); e.preventDefault(); this.entryAdd(data) }} />
                            }</span>
                        </div>
                    }) : <div className="entry-empty">{React.language('app.dash.form.empty')}</div>
                }
            </div>
        } else {
            return '';
        }

    }

    renderApplist = () => {
        const { apps } = this.state;
        let that = this;
        return <>
            {
                apps.map((data, index) => {
                    return <>
                        <div className={"applist-group"} title={data.name}>
                            {data.name}
                        </div>
                        {
                            data.apps.map((appdata, appindex) => {
                                return <div className={"applist-item "} >
                                    <div className='app-title' onClick={e => { that.onSelectApp(appdata._id, e) }}  >
                                        <i className="icon-bsy-sort-desc"></i>
                                        <div className={"app-icon color-cover-" + appdata.style.color}><div className={"imgbg-bsy-app imgbg-bsy-app-" + appdata.style.icon} /></div>
                                        <span className="app-name">{appdata.appname}</span>
                                        <span className={'right-entry-title'}>{
                                            this.findEntryS(appdata)
                                                ? <span className='read-tip'>{React.language('add.already')}</span>
                                                : <i className='icon-bsy-appAdd' onClick={(e) => { e.stopPropagation(); e.preventDefault(); appdata.type = "app"; this.entryAdd(appdata) }} />
                                        }</span>
                                    </div>
                                    {
                                        this.renderEntryList(appdata)
                                    }
                                </div>
                            })
                        }
                    </>
                })
            }
        </>
    }
    setIcon = (data) => {
        if ((data.customIconSwitch && data.style.newIcon)) {
            return data.style.newIcon
        } else if (data.customUrl) {
            return data.style.newIcon || data.style.icon
        } else {
            return data.style.icon
        }
    }
    onSortEnd = (data, groupInfo) => {
        const { oldIndex, newIndex } = data;
        const { speedyEntrys } = this.state;
        const scr = arrayMoveImmutable(speedyEntrys, oldIndex, newIndex);
        console.log(scr)
        this.setState({
            speedyEntrys: scr
        }, () => {
            this.getValue(scr);
        })

    };
    onGroupChange = (apps) => {
        console.log(apps)
        this.setState({
            speedyEntrys: apps
        }, () => {
            this.getValue(apps);
        })
    }
    renderSeachlist = () => {
        const { seachList } = this.state;

        return <div className='applist-item '>
            <div className='app-entrys' >
                {
                    seachList.map((data, index) => {
                        return <div className={'entry-item'} onClick={this.EntryClick} >
                            <i className={'entry-icon ' + BsyUtils.getFormIcon(data)} />
                            <span className={'entry-title'}>{data.name}</span>
                            <span className={'right-entry-title'}>{
                                this.findEntryS(data)
                                    ? <span className='read-tip'>{React.language('add.already')}</span>
                                    : <i className='icon-bsy-appAdd' onClick={e => { e.stopPropagation(); e.preventDefault(); this.entryAdd(data) }} />
                            }</span>
                        </div>
                    })
                }
            </div>
        </div>
    }
    renderGroupList = () => {
        const { speedyEntrys } = this.state;
        const normalizedData = speedyEntrys.map(({ appname, customName, ...rest }) => ({
            ...rest,
            name: appname || customName || rest.name, // 如果 appname 存在，则使用 appname，否则使用 name
        }));
        console.log(normalizedData)
        return <ReactSortable
            className="list-content"
            forceFallback={true}
            list={normalizedData}
            setList={this.onGroupChange}
            handle={".entry-move"}
        >
            {normalizedData.map((data, index) => {
                return <div className={'body-entry-item'} onClick={this.EntryClick} key={index}>
                    {
                        (data.iconType === "form" || data.iconType === "report" || data.iconType === "dash" || data.iconType === "scenes" || !data.customIconSwitch) && !data.customUrl && data.type !== "app" && <div className="entry-name">
                            <i className={'entry-icon 1 ' + BsyUtils.getFormIcon(data)} />
                            <span className={'entry-title'}>{data.customName || data.name || data.appname}</span>
                        </div>
                    }
                    {
                        (data.iconType === "app" || data.iconType === "url") && data.customIconSwitch && <div className="app-title">
                            <div className={"app-icon 2 color-cover-" + data.style.color}><div className={"imgbg-bsy-app imgbg-bsy-app-" + this.setIcon(data)} /></div>
                            <span className="app-name">{data.customName || data.appname || data.name}</span>
                        </div>
                    }
                    {
                        ((data.iconType === "system" && data.customIconSwitch) || data.customUrl) && data.iconType !== "image" && <div className="app-title">
                            <div className={"app-icon 3 color-cover-" + data.style.color}><div className={"imgbg-bsy-app imgbg-bsy-app-" + this.setIcon(data)} /></div>
                            <span className="app-name">{data.customName || data.appname || data.name}</span>
                        </div>
                    }
                    {
                        ((data.type === "app" && !data.customIconSwitch && data.parent === "default")) && <div className="app-title">
                            <div className={"app-icon 4 color-cover-" + data.style.color}><div className={"imgbg-bsy-app imgbg-bsy-app-" + data.style.icon} /></div>
                            <span className="app-name">{data.customName || data.appname || data.name}</span>
                        </div>
                    }
                    {
                        ((data.type === "app" && !data.customIconSwitch && data.parent !== "default")) && data.iconType !== "image" && <div className="app-title">
                            <div className={"app-icon 5 color-cover-" + data.style.color}><div className={"imgbg-bsy-app imgbg-bsy-app-" + this.setIcon(data)} /></div>
                            <span className={'entry-title'}>{data.customName || data.name || data.appname}</span>
                        </div>
                    }
                    {
                        (data.iconType === "image") && <div className="app-title">
                            <div className={`img-bg`} style={{ backgroundImage: `url(${data.imageUrl})`, backgroundSize: "100%" }}></div>
                            <span className="app-name">{data.customName || data.appname || data.name}</span>
                        </div>
                    }
                    <div className="entry-btn">
                        <span className={'entry-del'} onClick={e => { this.entryDel(data) }} ><i className='icon-remove' /></span>
                        <span className={'entry-move'}>
                            <DragHandle />
                        </span>
                    </div>

                </div>
            })}
        </ReactSortable>
    }
    render() {
        const { speedyEntrys, maxEntrys, key, entryList } = this.state;
        return (
            <div className={"dashboard-speedy-entry-config"}>

                <div className={"left-app-list"}>
                    <div className='applist-seach'>
                        <BsySearchResult
                            placeholder={React.language('form.search.placeholder')}
                            width={320}
                            height={350}
                            dockPosition="center"
                            async={{
                                url: '/dashboard/search',
                                data: {
                                    type: 'all',
                                    range: 'noStandard'
                                },
                                sucess: (items) => {
                                    return items.list
                                }
                            }}
                            onCreatResult={(res) => {
                                let otherItem = [];
                                let appItem = [];
                                if (res && res.length > 0) {
                                    res.map((val) => {
                                        if (val.type !== "app") {
                                            otherItem.push(val)
                                        } else {
                                            appItem.push(val)
                                        }
                                    })
                                }
                                return res && res.length > 0 ? <div className="searchAllAppFormReport t-searchAllAppFormReport">
                                    <ul className="searchFormDashReport">
                                        {
                                            appItem.length > 0 ? appItem.map((val) => {
                                                return val && <li key={val.id}>
                                                    <div className="contView">
                                                        <div className="menu-item" title={val.text}>
                                                            <div className={"app-icon color-cover-" + val.style.color}><div className={"imgbg-bsy-app imgbg-bsy-app-" + val.style.icon} /></div>
                                                            <span className="app-name" dangerouslySetInnerHTML={{ __html: val.titleHtml }}></span>
                                                            <span className={'right-entry-title'}>{
                                                                this.findEntryS(val)
                                                                    ? <span className='read-tip'>{React.language('add.already')}</span>
                                                                    : <i className='icon-bsy-appAdd' onClick={(e) => { e.stopPropagation(); e.preventDefault(); this.entryAdd1(e, val) }} />
                                                            }</span>
                                                        </div>
                                                        {val.mode === "dock" && <div className="dockItem" title={React.language('organization.external') + ':' + val.corp_name}>
                                                            {React.language('organization.external') + ':' + val.corp_name}
                                                        </div>}
                                                    </div>
                                                </li>
                                            }) : <li className="emptySearchForm">
                                                {/* {React.language('dash.form.empty')} */}
                                            </li>
                                        }
                                    </ul>
                                    <ul className="searchFormDashReport ">
                                        {
                                            otherItem.length > 0 ? otherItem.map((val) => {
                                                console.log(val.icon)
                                                return val && <li key={val.id}>
                                                    <div className="contView">
                                                        <div className="menu-item" title={val.text}>
                                                            <i className={`node-icon icon-bsy-${val.type}${!val.hasCoop ? "-flow" : ""} ${val.icon <= 24 ? `icon-bsy-form-'${val.icon}` : `icon-new-bsy-form-${val.icon}`}`} />
                                                            <span className={this.findEntryS(val)?"t-text-span":"t-text-icon"} dangerouslySetInnerHTML={{ __html: val.titleHtml }} />
                                                            <span className={'right-entry-title'}>{
                                                                this.findEntryS(val)
                                                                    ? <span className='read-tip'>{React.language('add.already')}</span>
                                                                    : <i className='icon-bsy-appAdd' onClick={(e) => { e.stopPropagation(); e.preventDefault(); this.entryAdd1(e, val) }} />
                                                            }</span>
                                                        </div>
                                                        <div className="appNameItem">
                                                            <span>{val.appName}</span>
                                                        </div>
                                                        {val.mode === "dock" && <div className="dockItem" title={React.language('organization.external') + ':' + val.corp_name}>
                                                            {React.language('organization.external') + ':' + val.corp_name}
                                                        </div>}
                                                    </div>
                                                </li>
                                            }) : <li className="emptySearchForm">
                                                {React.language('dash.form.empty')}
                                            </li>
                                        }
                                    </ul>
                                </div> : <div className="emptySearchAll">
                                    {React.language('field.location.empty')}
                                </div>
                            }}
                            getValue={this.getSearchValue}
                            onSearch={this.onSearch}
                            type={window.mode}
                        // iconName="icon-bsy-reportmenu-0"
                        />
                    </div>
                    <div className='applist'>
                        {
                            !key ? this.renderApplist() : this.renderSeachlist()
                        }
                    </div>
                </div>
                <div className={"right-speedy-entrys"}>
                    <div className='entrys-num'>
                        <span >
                            {
                                React.language("add.already.num", {
                                    num: speedyEntrys.length
                                })
                            }
                        </span>
                    </div>
                    <div className='speedy-entrys'>
                        {this.renderGroupList()}
                    </div>
                </div>
            </div>
        )
    }
}